<app-layout-simple>
  <main *appLayoutContent>
    <app-wait></app-wait>
  </main>
</app-layout-simple>
